export default __webpack_public_path__ + "static/media/header_4.c84f5e85.jpg";